import(/* webpackMode: "eager" */ "/Users/misterjoessef/WebDev/DTask/packages/web/next13frontend/app/contact/page.tsx");
